"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseTransport = require("./base");

var websocket = require("websocket-stream");
var jsonlines = require("jsonlines");

var WebSocketTransport = function (_BaseTransport) {
  _inherits(WebSocketTransport, _BaseTransport);

  function WebSocketTransport(options, node) {
    _classCallCheck(this, WebSocketTransport);

    var _this = _possibleConstructorReturn(this, (WebSocketTransport.__proto__ || Object.getPrototypeOf(WebSocketTransport)).call(this, options, node));

    _this.address = "ws:" + (options.host || "localhost") + ":" + options.port;
    _this.options = options.server ? { server: options.server } : { port: options.port };
    return _this;
  }

  _createClass(WebSocketTransport, [{
    key: "connect",
    value: function connect(address) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var socket = websocket(address).on("connect", function () {
          var peer = { socket: socket, address: address };
          _this2._initOutgoingPeer(peer);
          resolve(peer);
        }).on("error", function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect(peer) {
      return new Promise(function (resolve) {
        peer.socket.on("close", resolve);
        peer.socket.end();
      });
    }
  }, {
    key: "start",
    value: function start() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.server = websocket.createServer(_this3.options, function (socket, request) {
          _this3._initIncomingPeer({ socket: socket, address: socket.url });
        }).on("error", function (error) {
          console.log("SERVER ERROR", error);
        }).on("listening", resolve);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.server.close(function (err) {
          return err ? reject(err) : resolve();
        });
        return Promise.all(_this4.peers.map(function (peer) {
          return new Promise(function (resolve) {
            peer.socket.on("close", resolve);
            peer.socket.end();
          });
        }));
      });
    }
  }, {
    key: "_initPeer",
    value: function _initPeer(peer) {
      peer.input = peer.socket.pipe(jsonlines.parse());
      peer.output = jsonlines.stringify();
      peer.output.pipe(peer.socket);

      // https://github.com/websockets/ws/issues/1256
      peer.socket.on("error", function (error) {
        // console.log(error + "")
      });

      _get(WebSocketTransport.prototype.__proto__ || Object.getPrototypeOf(WebSocketTransport.prototype), "_initPeer", this).call(this, peer);
    }
  }]);

  return WebSocketTransport;
}(BaseTransport);

module.exports = WebSocketTransport;


//////////////////
// WEBPACK FOOTER
// ../lib/transport/websocket.js
// module id = 561
// module chunks = 0